.Menu {
    position: absolute;
    top: 20px;
    right: 20px;
    a {
        text-decoration: none;

        display: inline-block;
        text-align: center;
        border-radius: 50%;
        margin-left: 15px;
        color: var(--primary-foreground);
        &:visited {
            color: var(--primary-foreground);
        }
    }
}
